export const ERRO_ASSUNTO_OBRIGATORIO = 'Formulário não está valido. Preencha o assunto.';
export const ERRO_DADOS_OBRIGATORIOS = 'Formulário não está valido. Preencha as informações obrigatórias:';
export const ERRO_DADOS_NAO_GRAVADOS = 'Ocorreu um erro inesperado. Não foi possível gravar os dados do formulário.';
export const ERRO_SERVIDOR = 'Não foi possível concluir a operação devido a um erro no servidor. Tente novamente mais tarde.';
export const ERRO_COMUNICACAO_SERVIDOR = 'Não foi possível comunicar com o servidor. Verifique sua conexão e tente novamente.';
export const ERRO_SENHA_NAO_ALTERADA = 'Ocorreu um erro inesperado. Não foi possível alterar a senha.';
export const ERRO_FORMULARIO_INVALIDO = 'Formulário não está válido.';
export const ERRO_BUSCA_CEP = 'Não foi possivel buscar o CEP. Por favor preencha o endereço manualmente.';

export const ERRO_AUTENTICACAO_FALHOU = 'Usuário não está autenticado.';
export const ERRO_AUTENTICACAO_CAPTCHA = 'É necessário realizar a confirmação "Não sou um robô".';
export const ERRO_FORMATO_EMAIL_INVALIDO = 'E-mail informado no formato incorreto.';
export const ERRO_SENHA_OBRIGATORIA = 'Senha obrigatória.';
export const ERRO_LOGIN_OBRIGATORIO = 'Login obrigatório.';
export const ERRO_CAMPOS_OBRIGATORIOS = 'Obrigatório informar um dos campos.';
export const ERRO_EMAIL_OBRIGATORIO = 'E-mail obrigatório.';
export const ERRO_CAMPO_OBRIGATORIO = 'Campo de preenchimento obrigatório.';
export const ERRO_DATA_OBRIGATORIA = 'Data deve ser informada.';
export const ERRO_RESPOSTA_OBRIGATORIA = 'A resposta deve ser informada.';
export const ERRO_STATUS_INVALIDO = 'Por favor selecione um status diferente.';

export const OK_DADOS_GRAVADOS = 'Dados gravados com sucesso.';
export const OK_DADOS_ALTERADOS = 'Dados alterados com sucesso.';
export const OK_SENHA_ALTERADA = 'Senha definida com sucesso!';

export const OK_MANIFESTO_ENVIADO = 'Manifestação enviada com sucesso.';
export const OK_MANIFESTO_SALVO = 'Sua manifestação foi salva como rascunho.';

export function OK_AUTENTICACAO(nome: String) {
  return 'Olá, ' + nome + '. Login realizado com sucesso.';
}

export function OK_PROTOCOLO_MANIFESTACAO(id: Number) {
  return 'Manifestação enviada com sucesso. Número de protocolo: ' + id + '.';
}

export function OK_PROTOCOLO_MANIFESTACAO_CODIGO(manifestacaoCodigo: string) {
  return 'Manifestação enviada com sucesso. Número de protocolo: ' + manifestacaoCodigo + '.';
}

export function OK_PROTOCOLO_RASCUNHO(id: Number) {
  return 'Sua manifestação foi salva como rascunho. Número de protocolo: ' + id + '.';
}

export function OK_PROTOCOLO_RASCUNHO_MANIFESTACAO_CODIGO(manifestacaoCodigo: string) {
  return 'Sua manifestação foi salva como rascunho. Número de protocolo: ' + manifestacaoCodigo + '.';
}

export function OK_ENVIO_EMAIL(nome: String, email: String) {
  return 'Prezado(a) ' + nome + ', um e-mail de redefinição de senha foi enviado para ' + email
    + '. Por favor, verifique sua caixa de entrada.';
}

export const MSG_LOGIN_EMAIL_SENHA = 'Por favor, insira o seu e-mail e senha para acessar o formulário solicitado.';
export const MSG_LOGIN_GOVBR_FALE_COM_RH = 'Para acessar o Fale com o RH, faça login com o GOV.BR.';

export const ERRO_CONSULTAR_PROCESSO = 'Não foi possível realizar consulta. Confirme os dados inseridos, ou tente novamente mais tarde.';

export const NOVA_SENHA_OBRIGATORIA = 'Senha obrigatória.';
export const CONFIRMACAO_NOVA_SENHA_OBRIGATORIA = 'Favor confirmar nova senha.';
export const SENHA_DIFERENTE = 'Senha informada não corresponde à nova senha.';
export const QUERY_VAZIA = 'Por favor acesse o link enviado para seu e-mail para redefinir sua senha.';

// Arquivos anexados
export const ERRO_ANEXAR_ARQ = 'Erro ao anexar arquivo';
export const ERRO_FORMATO_ARQ = 'Tipo de arquivo não permitido.';
export const ERRO_TAMANHO_ARQ = 'Tamanho máximo de arquivo atingido. Permitido até 10MB.';
export const ERRO_NOME_IGUAL_ARQ = 'Não é possível adicionar arquivos com mesmo nome.';
export function ERRO_LIMITE_ARQ(qtde: Number) {
  return 'Número máximo de anexos atingido. Permitido até ' + qtde + ' anexos.';
}

//Manifestação
export const MSG_OBG_ASSUNTO = 'Favor selecionar um assunto para abertura do formulário.\n';
export const MSG_OBG_CLASSIFICACAO = 'Selecione uma ou mais classificações para inclusão da manifestação.\n';

// Consulta Serviço Notarial
export const MSG_CONSULTA_SERVICO_NOTARIAL_ERRO = "Erro ao realizar a busca das informações da serventia.";
export const MSG_CONSULTA_SERVICO_NOTARIAL_VALIDAR_ENVIO = "Favor preencher todos os campos antes de realizar o envio das informações.";
export const MSG_CONSULTA_SERVICO_NOTARIAL_NUMERO_INVALIDO = "O sistema não identificou o código informado. Favor conferir a numeração.";
export const MSG_CONSULTA_SERVICO_NOTARIAL_NUMERO_INCORRETO = "O valor digitado não é um número CNS válido."

// Reclamação
export const MSG_LIMITE_DESCRICAO = 'Você excedeu o limite de caracteres permitido. Número máximo de caracteres permitido 5.000.\n';
export const MSG_RECLAMACAO_OBG_COMARCA = 'Comarca obrigatório.\n';

// Reclamação - Cartórios Extrajudiciais
export const MSG_OBG_MUNICIPIO = 'Selecione um município.\n';
export const MSG_OBG_CARTORIO = 'Selecione um cartório.\n';
export const MSG_OBG_DESCRICAO = 'Favor preencher o campo de descrição para inclusão da manifestação.\n';

// Reclamação - Processo
export const MSG_OBG_TIPO_JUSTICA = 'Selecione o tipo de justiça (1ª ou 2ª Instância).\n';
export const MSG_OBG_NUM_PROCESSO = 'Informe o número do processo.\n';
export const MSG_OBG_NUM_PROCESSO_VALIDO = 'Informe um número de processo válido.\n';
export const MSG_OBG_TIPO_JUSTICA_OPCAO = "Selecione uma das opções do tipo de justiça da 1ª Instância. \n";
export const MSG_OBG_TIPO_JUSTICA_OPCAO_ANEXO = "É necessário anexar pelo menos um arquivo com informações do documento de identidade e comprovante de residência. \n";

//Cadastro Usuario
export const MSG_OBG_SELFORM = 'Favor selecionar um formulário.';
export const MSG_OBG_EMAIL = 'E-mail obrigatório.';
export const MSG_OBG_VALIDEMAIL = 'Confirmação de e-mail obrigatório.';
//Formato de e-mail inválido.
//A senha deve conter 8 dígitos e possuir letras e números.
export const MSG_OBG_VALIDSENHA = 'A confirmação de senha não confere com a senha informada no campo “senha”.';
export const MSG_OBG_SENHA = 'Campo senha obrigatório.';
export const MSG_OBG_CONFSENHA = 'Confirmação de senha obrigatória.';
export const MSG_OBG_NOME = 'Informe o nome.';
export const MSG_OBG_RAZAOSOCIAL = 'Informe a razão social.';
export const MSG_OBG_REPEMPRESA = 'Informe o nome do representante da empresa.';
export const MSG_OBG_DTNASC = 'Data de nascimento obrigatória.';
//CPF inválido.
//CNPJ inválido.
//Informe apenas números no RG.
export const MSG_OBG_CPF = 'CPF obrigatório.';
export const MSG_OBG_CNPJ = 'CNPJ obrigatório.';
export const MSG_CNPJ_INVALIDO = 'CNPJ inválido.';
export const MSG_CPF_INVALIDO = 'CPF inválido.';
export const MSG_OBG_ESCOL = 'Selecione sua escolaridade.';
export const MSG_OBG_CARGOFUNC = 'Selecione cargo/função exercido.';
export const MSG_OBG_RESP = 'Informe o nome do responsável se menor de 18 anos.';
export const MSG_OBG_CEP = 'Informe o CEP ou clique no ícone de busca.';
export const MSG_OBG_NUM = 'Informe o número.';
export const MSG_OBG_COMPL = 'Informe o complemento.';
export const MSG_OBG_LOGRADOURO = 'Informe o logradouro.';

export const MSG_NENHUM_REGISTRO = 'Nenhum registro localizado.';

// Relatórios
export const ERRO_GERACAO_ARQUIVO = 'Erro durante a geração do arquivo.';

// Denúncia
export const MSG_DENUNCIA_OBG_ASSUNTO = 'Assunto obrigatório.\n';
export const MSG_DENUNCIA_OBG_NOME_CARTORIO = 'Nome do Cartório obrigatório.\n';
export const MSG_DENUNCIA_OBG_LOCALIDADE = 'Localidade obrigatório.\n';
export const MSG_DENUNCIA_OBG_MUNICIPIO = 'Município obrigatório.\n';
export const MSG_DENUNCIA_OBG_COMARCA = 'Comarca obrigatório.\n';
export const MSG_DENUNCIA_OBG_DESCRICAO_DENUNCIA = 'Descrição da denúncia obrigatório.\n';
export const MSG_DENUNCIA_OBG_CLASSIFICACAO = 'Selecione uma classificação para inclusão da manifestação.\n';

// Denúncia - Tortura ou maus-tratos de pessoa sob custódia policial no Sistema Prisional ou Socioeducativo
export const MSG_DENUNCIA_OBG_PUBLICO_ORIGEM_NOTIFICACAO = 'Poder Judiciário ou Público Externo da Origem Notificação obrigatório.\n';

// Denúncia - Infância e Juventude
export const MSG_DENUNCIA_OBG_COMARCA_OCORRENCIA = 'Comarca da ocorrência obrigatória.\n';
export const MSG_DENUNCIA_OBG_NUMERO_PROCESSO = 'Número do processo obrigatório quando existir processo em andamento.\n';
export const MSG_DENUNCIA_OBG_TIPOS_DEMANDA = 'Selecione pelo menos um tipo de demanda.\n';
export const MSG_DENUNCIA_OBG_NOME_UNIDADE_ACOLHIMENTO = 'Nome da Unidade de Acolhimento obrigatório.\n';
export const MSG_DENUNCIA_OBG_ORIGEM_NOTIFICACAO = 'Origem Notificação obrigatório.\n';
export const MSG_DENUNCIA_OBG_TIPO_PESSOA_NOTIFICANTE = 'Tipo de Pessoa Notificante obrigatório.\n';
export const MSG_DENUNCIA_OBG_NOME_NOTIFICANTE = 'Nome do Notificante/Unidade Judiciária obrigatório.\n';
export const MSG_DENUNCIA_OBG_NOME_SOCIAL_NOTIFICANTE = 'Nome Social obrigatório.\n';
export const MSG_DENUNCIA_OBG_CPF_NOTIFICANTE = 'CPF obrigatório.\n';
export const MSG_DENUNCIA_OBG_CNPJ_NOTIFICANTE = 'CNPJ obrigatório.\n';
export const MSG_DENUNCIA_OBG_RG_NOTIFICANTE = 'RG obrigatório.\n';
export const MSG_DENUNCIA_OBG_ORGAO_EXPEDIDOR_NOTIFICANTE = 'Órgão Expedidor obrigatório.\n';
export const MSG_DENUNCIA_OBG_UF_ORGAO_EXPEDIDOR_NOTIFICANTE = 'UF Expedição obrigatório.\n';
export const MSG_DENUNCIA_OBG_EMAIL_NOTIFICANTE = 'E-mail obrigatório.\n';
export const MSG_DENUNCIA_OBG_VITIMAS = 'Vítima(s) obrigatório.\n';
export const MSG_DENUNCIA_OBG_ORGAO_VINCULADO_AGRESSORES = 'Órgão a que está vinculado o(s) Agressor(es) obrigatório.\n';
export const MSG_DENUNCIA_OBG_OUTROS_ORGAOS = 'Outros Órgãos obrigatório.\n';
export const MSG_DENUNCIA_OBG_LOCAL_FATO = 'Local onde ocorreu(ram) o(s) fato(s) obrigatório.\n';

// Denúncia Anônima
export function OK_PROTOCOLO_DENUNCIA_ANONIMA(id: Number) {
  return 'Manifestação enviada com sucesso. Número de protocolo: ' + 'DA' + id + '.';
}

// LGPD
export const ERRO_NUMERO_PROCESSO_SEI = 'Número do processo SEI inválido.';
export const MSG_OBG_IDENTIFICACAO_TITULAR_ANEXO = 'É obrigatório anexar um documento de identificação oficial com foto.';
export const MSG_OBG_FOTO_REQUERENTE_ANEXO = 'É obrigatório anexar uma foto do(a) requerente com documento de identificação próximo ao rosto';
export const MSG_OBG_DOCUMENTO_LEGAL_ANEXO = 'É obrigatório anexar uma procuração lavrada em cartório ou outro documento legal equivalente';
export const MSG_OBG_DATA_NASCIMENTO = 'A Data de Nascimento é obrigatória';

// PopUp
// TODO - Serão concentradas todas as mensagens relacionadas ao pop up de confirmação de cada tipo de Manifestação
export const MSG_POPUP_CONFIRMACAO_DENUNCIA = "Você esta criando uma denúncia no TJMG. Deseja continuar com sua manifestação ?";

// Solicitação
export const MSG_OBG_TEMA = 'Favor selecionar um tema.\n';

// Usuário
export const MSG_USUARIO_DESATIVADO = 'Usuário desativado com sucesso.\n';
export const MSG_USUARIO_REATIVADO = 'Usuário reativado com sucesso.\n';
export const MSG_LOGIN_USUARIO_DESATIVADO = 'Usuário sem permissão de acesso.';


export const MSG_CADASTRO_USUARIO_GOV_BR = 'Você ainda não possui cadastro na base de dados no âmbito do TJMG. Clique em OK para continuar e realizar o cadastro. Conforme disposto na Lei nº 13.460, de 2017, os seus dados pessoais de login, incluindo seu nome, serão acessados somente pelas unidades do Tribunal de Justiça de Minas Gerais.';

export const MSG_CADASTRO_PENDENTE_ATIVACAO_USUARIO_GOV_BR = 'Você possui cadastro pendente de liberação na base de dados no âmbito do TJMG. Para liberação, pesquise em sua caixa de entrada de e-mails a mensagem com o assunto “Fale com o TJMG - Ativar conta” ou entre em contato com o endereço suportesei@tjmg.jus.br.';

// Sessão do login
export const MENSAGEM_EXPIRAR_SESSAO = 'Resta apenas 1 minuto para a sua sessão expirar. Deseja renovar?';
export const ERRO_RENOVAR_SESSAO = 'Ocorreu um erro ao renovar sua sessão.';
export const MENSAGEM_SESSAO_EXPIRADA = 'Sua sessão expirou, logue novamente.';

export const MENSAGEM_SESSAO_EXPIRADA_GOV_BR = 'A sessão do Login Único gov.br expirou.';
// Sessão da CPE
export const MSG_OBG_PARTE_REQUERENTE = 'Informe a parte dentro de Informações do Requerente';
export const MSG_OBG_AUTOR_REQUERENTE = 'Informe o autor do presente requerimento';
export const MSG_OBG_TELEFONE = 'Informe número de telefone';
export const MSG_OBG_OAB_ADVOGADO = 'Informe um número OAB válido';
export const MSG_OBG_NOME_ADVOGADO = 'Informe o nome do advogado';
export const MSG_OBG_TURMA_RECURSAL = 'Informe Turma Recursal';
export const MSG_OBG_INFORME_ANEXO = 'Informe comprovante de pagamento';
export const MSG_OBG_INFORME_ANEXO_JUNTADA_DOCUMENTO = 'Informe anexo juntada documento';
export const MSG_OBG_ADESAO_WHATSAPP = 'Favor marcar a adesão';
export const MSG_OBG_MOTIVO_REQUERIMENTO = 'Favor selecionar um motivo de requerimento';
export const MSG_OBG_BENEFICIARIO = 'Favor selecionar Beneficiário de Justiça ou Assistência';
export const MSG_OBG_MOTIVO_DESARQUIVAMENTO_AUTOS = 'Favor Informar um motivo do desarquivamento de autos';
